import { Component, Input } from '@angular/core';
import { routes } from '../../../shared/models/routes/routes.model';

@Component({
  selector: 'app-breadcrumbs',
  standalone: false,
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss'
})
export class BreadcrumbsComponent {
  routes = routes
  @Input() title: string | undefined;
  @Input()
  breadcrumbItems!: {
    active?: boolean;
    label?: string;
  }[];

  Item!: {
    label?: string;
  }[];
}
